/**
 * animation time used for all open/closing animation for accordion
 */
export const ANIMATION_OPEN_CLOSE_DURATION = 200;
